import { useCallback } from 'react'

import { useSegment } from '../../../../../../../hooks'

type ImportTrackArgs =
  | { phase: 'Started' }
  | { phase: 'Completed'; contactCount: number }
  | { phase: 'Failed'; errorReason: string }

const EVENT_NAME_BY_PHASE: Record<ImportTrackArgs['phase'], string> = {
  Started: 'xxx - commerce - Contact Import Started',
  Completed: 'Contact List Imported (Client)',
  Failed: 'xxx - commerce - Contact Import Failed',
}

export const useTrackContactsImport = () => {
  const { track } = useSegment()

  const trackImport = useCallback(
    (args: ImportTrackArgs) => {
      const { phase, ...payload } = args
      track(EVENT_NAME_BY_PHASE[phase], { fileFormat: 'csv', ...payload })
    },
    [track],
  )

  return { trackImport }
}
